import styles from './index.module.scss';
export default function UnitPrice({
  productUnitPriceFloor,
}: {
  productUnitPriceFloor: { unitPrice: string; unitPriceDesc: string };
}) {
  const { unitPriceDescIntergation }: Record<string, any> = productUnitPriceFloor || {};

  return (
    unitPriceDescIntergation && (
      // 无数据记得隐藏
      <div className={styles.unitPrice}>{unitPriceDescIntergation}</div>
    )
  );
}
